/**
 * Created with JetBrains WebStorm.
 * User: yujy
 * Date: 16-03-29
 * Time: 上午10:41
 * To change this template use File | Settings | File Templates.
 */

export default class fvRender {
    constructor(){

    }
    Render(obj,canvas) {
        if(obj==undefined){
            console.warn("渲染对象不能为空");
            return;
        }
        if(obj.renderConfig == undefined) return;
        var rd = obj.renderConfig;
        var m_fRotate = 3.1415926/180.00013* parseFloat(rd.rotate); //跟draw的精度一样
        if(rd.color){
            var colorNum = rd.color.length;
        }

        var rect = fcRect();
            rect.left = 0;
            rect.top = 0;
            rect.bottom = parseFloat(obj.height);
            rect.right = parseFloat(obj.width);
            rect.width = parseFloat(obj.width);
            rect.height = parseFloat(obj.height);

        switch (obj.renderType){
            case 1:  //模式1
                move.RenderMove(canvas,rect,rd.grade,"",rd.color,colorNum,rd.colorGrade,m_fRotate);
                break;
            case 2:  //模式2
                contract.RenderContract(canvas,rect,rd.grade,"",rd.color,colorNum,rd.colorGrade,m_fRotate,rd.rendShape,rd.centerPos,rd.rotate);
                break;
            case 3:  //模式3
                grid.RenderGrid(canvas,obj,obj.color,rd.grade);
                break;
            case 4:  //canvas线性渐变效果
                line.RenderLine(canvas,rect,obj);
                break;
            case 5:  //canvas路径渐变效果
                path.RenderPath(canvas,rect,obj);
                break;
            case 6:  //canvas纹理渐变效果
                texture.RenderTexture(canvas,rect,obj);
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/render/fvRender.js